<template>
	<div class="editPreInfo">
		<el-card>
			<div class="jump-btn">
				<el-button type="primary" @click="back">返回上一级</el-button>
			</div>
			<el-form v-if="Object.keys(ruleForm).length>0" :model="ruleForm" :rules="rules" ref="ruleForm" class="wid100"
				:label-width="require('@/config/enum').c_ws13" :label-suffix="require('@/config/enum').c_colon">
				<el-form-item label="IP地址" prop="LanIP">
					<el-input disabled v-model="ruleForm.MsgBody.CommonParam.LanIP" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="掩码地址" prop="LanMask">
					<el-input disabled v-model="ruleForm.MsgBody.CommonParam.LanMask" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="网关地址" prop="LanGateway">
					<el-input disabled v-model="ruleForm.MsgBody.CommonParam.LanGateway" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="MAC地址" prop="LanMAC">
					<el-input disabled v-model="ruleForm.MsgBody.CommonParam.LanMAC" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="服务器IP" prop="RegIP">
					<el-input disabled v-model="ruleForm.MsgBody.CommonParam.RegIP" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="服务器端口" prop="RegPort">
					<el-input disabled v-model="ruleForm.MsgBody.CommonParam.RegPort" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="电梯注册代码" prop="LiftCode">
					<el-input disabled v-model="ruleForm.MsgBody.DeviceParam.LiftCode" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="安装位置" prop="Address">
					<el-input disabled v-model="ruleForm.MsgBody.DeviceParam.Address" class="item-input"></el-input>
				</el-form-item>
				<!-- <el-form-item label="平层间距（mm）" prop="MsgBody.DeviceParam.ElevFloorSpacing">
					<el-input v-model="ruleForm.MsgBody.DeviceParam.ElevFloorSpacing" class="item-input"></el-input>
				</el-form-item> -->
				<el-form-item label="遮光板长度（mm）" prop="MsgBody.DeviceParam.ElevLightShieldLength">
					<el-input v-model.number="ruleForm.MsgBody.DeviceParam.ElevLightShieldLength" class="item-input">
					</el-input>
				</el-form-item>
				<el-form-item label="总楼层数" prop="MsgBody.DeviceParam.ElevFloorNum">
					<el-input v-model.number="ruleForm.MsgBody.DeviceParam.ElevFloorNum" @blur="getFloorList" class="item-input">
					</el-input>
				</el-form-item>
				<el-form-item label="地下楼层数" prop="MsgBody.DeviceParam.ElevFloorNumUnderGround">
					<el-input v-model.number="ruleForm.MsgBody.DeviceParam.ElevFloorNumUnderGround" @blur="getFloorList"
						class="item-input">
					</el-input>
				</el-form-item>
				<el-form-item label="楼层命名" v-if="floorList.length>0">
					<div v-for="(item,index) in floorList" :key="index" style="margin: 10px;">
						<span style="display: inline-block;width: 50px;text-align: right;">{{ item.name }}层：</span>
						<el-input v-model="item.value" placeholder="请输入楼层名称" class="item-input">
						</el-input>
					</div>
				</el-form-item>
				<el-form-item label="基准楼层">
					<el-select v-model="ruleForm.MsgBody.DeviceParam.FloorBase">
						<el-option label="无" :value='0'></el-option>
						<el-option label="1层" :value='1'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="双门" prop="MsgBody.DeviceParam.TwinDoor">
					<el-select v-model="ruleForm.MsgBody.DeviceParam.TwinDoor">
						<el-option label="单门" :value=0></el-option>
						<el-option label="双门" :value='1'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="最大速度（mm/s）" prop="MsgBody.DeviceParam.ElevMaxSpeed">
					<el-input v-model.number="ruleForm.MsgBody.DeviceParam.ElevMaxSpeed" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="平层无动作清速度延时（s）" prop="MsgBody.DeviceParam.NoActionClearTime">
					<el-input v-model.number="ruleForm.MsgBody.DeviceParam.NoActionClearTime" class="item-input">
					</el-input>
				</el-form-item>
				<el-form-item label="平层后清速度延时（s）" prop="MsgBody.DeviceParam.LvlClearTime">
					<el-input v-model.number="ruleForm.MsgBody.DeviceParam.LvlClearTime" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="门关后锁定有人延时（s）" prop="MsgBody.DeviceParam.DoorCloseJudgeTime">
					<el-input v-model.number="ruleForm.MsgBody.DeviceParam.DoorCloseJudgeTime" class="item-input">
					</el-input>
				</el-form-item>
				<el-form-item label="锁定有人后转到无人时间（s）" prop="MsgBody.DeviceParam.JudgeNoPeopleTime">
					<el-input v-model.number="ruleForm.MsgBody.DeviceParam.JudgeNoPeopleTime" class="item-input">
					</el-input>
				</el-form-item>
				<el-form-item label="非平层故障困人报警延时（s）" prop="MsgBody.DeviceParam.AlarmPeopleTime">
					<el-input v-model.number="ruleForm.MsgBody.DeviceParam.AlarmPeopleTime" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="非平层故障无人报警延时（s）" prop="MsgBody.DeviceParam.AlarmNoPeopleTime">
					<el-input v-model.number="ruleForm.MsgBody.DeviceParam.AlarmNoPeopleTime" class="item-input">
					</el-input>
				</el-form-item>
				<el-form-item label="平层困人报警延时（s）" prop="MsgBody.DeviceParam.NoAlarmPeopleTime">
					<el-input v-model.number="ruleForm.MsgBody.DeviceParam.NoAlarmPeopleTime" class="item-input">
					</el-input>
				</el-form-item>
				<el-form-item label="超速倍数" prop="MsgBody.DeviceParam.OverSpeed">
					<el-input v-model.number="ruleForm.MsgBody.DeviceParam.OverSpeed" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="冲顶屏蔽">
					<el-select v-model="ruleForm.MsgBody.DeviceParam.CollideUpMask">
						<el-option label="不屏蔽" :value='0'></el-option>
						<el-option label="屏蔽" :value='1'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="蹲底屏蔽">
					<el-select v-model="ruleForm.MsgBody.DeviceParam.CollideBottomMask">
						<el-option label="不屏蔽" :value='0'></el-option>
						<el-option label="屏蔽" :value='1'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="运行中开门屏蔽">
					<el-select v-model="ruleForm.MsgBody.DeviceParam.DoorOpenRunMask">
						<el-option label="不屏蔽" :value='0'></el-option>
						<el-option label="屏蔽" :value='1'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="门区外停梯屏蔽">
					<el-select v-model="ruleForm.MsgBody.DeviceParam.NoLvlMask">
						<el-option label="不屏蔽" :value='0'></el-option>
						<el-option label="屏蔽" :value='1'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="超速屏蔽">
					<el-select v-model="ruleForm.MsgBody.DeviceParam.OverSpeedMask">
						<el-option label="不屏蔽" :value='0'></el-option>
						<el-option label="屏蔽" :value='1'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="其他困人屏蔽">
					<el-select v-model="ruleForm.MsgBody.DeviceParam.PeopleTrapMask">
						<el-option label="不屏蔽" :value='0'></el-option>
						<el-option label="屏蔽" :value='1'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="意外移动屏蔽">
					<el-select v-model="ruleForm.MsgBody.DeviceParam.MoveAbnomalMask">
						<el-option label="不屏蔽" :value='0'></el-option>
						<el-option label="屏蔽" :value='1'></el-option>
					</el-select>
				</el-form-item>
				<!-- <el-button class="detailbtn" type="primary" @click="save()" :disabled="isDisabled">
					{{$t('lang.btn_save')}}</el-button> -->
				<el-button class="detailbtn" type="primary" @click="save()">
					{{$t('lang.btn_save')}}</el-button>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			var maxOverSpeed = (rule, value, callback) => {
				const reg = /^(110|111|112|113|114|115|116|117|118|119|120)$/
				// 当数据为空时，不进行校验
				if (!value) {
					return callback()
				}
				setTimeout(() => {
					if (reg.test(value)) {
						callback()
					} else {
						callback(new Error('请输入110到120之间的整数'))
					}
				}, 100)
			}
			var numReg = (rule, value, callback) => {
				const reg = /^\d+$/
				// 当数据为空时，不进行校验
				if (!value) {
					return callback()
				}
				setTimeout(() => {
					if (reg.test(value)) {
						callback()
					} else {
						callback(new Error('请输入正整数'))
					}
				}, 100)
			}
			return {
				isDisabled: false,
				parentData: {},
				regcode: '',
				floorList: [],
				ruleForm: {},
				rules: {
					'MsgBody.DeviceParam.ElevFloorSpacing': [{
						required: true,
						message: '请输入平层间距(正整数)',
						trigger: 'blur'
					}, {
						validator: (rule, value, callback) => {
							if (/^[1-9]\d*$/.test(value) == false) {
								callback(new Error('请输入平层间距(正整数)'))
							} else {
								callback()
							}
						},
						trigger: 'blur',
					}],
					'MsgBody.DeviceParam.ElevLightShieldLength': [{
						required: true,
						message: '请输入遮光板长度(正整数)',
						trigger: 'blur'
					}, {
						validator: (rule, value, callback) => {
							if (/^[1-9]\d*$/.test(value) == false) {
								callback(new Error('请输入遮光板长度(正整数)'))
							} else {
								callback()
							}
						},
						trigger: 'blur',
					}],
					'MsgBody.DeviceParam.ElevFloorNum': [{
						required: true,
						message: '请输入总楼层数(正整数)',
						trigger: 'blur'
					}, {
						validator: (rule, value, callback) => {
							if (/^[1-9]\d*$/.test(value) == false) {
								callback(new Error('请输入总楼层数(正整数)'))
							} else {
								callback()
							}
						},
						trigger: 'blur',
					}],
					'MsgBody.DeviceParam.ElevFloorNumUnderGround': [{
						required: true,
						message: '请输入地下楼层数(正整数)',
						trigger: 'blur'
					}, {
						validator: (rule, value, callback) => {
							if (/^[0-9]\d*$/.test(value) == false) {
								callback(new Error('请输入地下楼层数(正整数)'))
							} else {
								callback()
							}
						},
						trigger: 'blur',
					}],
					'MsgBody.DeviceParam.TwinDoor': [{
						required: true,
						message: '请选择单双门',
						trigger: 'change'
					}],
					'MsgBody.DeviceParam.ElevMaxSpeed': [{
						required: true,
						message: '请输入最大速度(正整数)',
						trigger: 'blur'
					}, {
						validator: (rule, value, callback) => {
							if (/^[1-9]\d*$/.test(value) == false) {
								callback(new Error('请输入最大速度(正整数)'))
							} else {
								callback()
							}
						},
						trigger: 'blur',
					}],
					'MsgBody.DeviceParam.OverSpeed': {
						validator: maxOverSpeed
					},
					'MsgBody.DeviceParam.NoActionClearTime': {
						validator: numReg
					},
					'MsgBody.DeviceParam.LvlClearTime': {
						validator: numReg
					},
					'MsgBody.DeviceParam.DoorCloseJudgeTime': {
						validator: numReg
					},
					'MsgBody.DeviceParam.JudgeNoPeopleTime': {
						validator: numReg
					},
					'MsgBody.DeviceParam.AlarmPeopleTime': {
						validator: numReg
					},
					'MsgBody.DeviceParam.AlarmNoPeopleTime': {
						validator: numReg
					},
					'MsgBody.DeviceParam.NoAlarmPeopleTime': {
						validator: numReg
					},
				},
			}
		},
		created() {
			this.parentData = this.$route.query.object
			this.regcode = this.$route.query.object.Registercode
			this.getDeviceRead()
		},
		watch: {
			ruleForm: {
				handler(newVal, oldVal) {
					// form数据变化时 会调用此方法
					let tempRule = JSON.stringify(newVal)
					if (tempRule == this.saveData) {
						// 没变
						// this.isDisabled = true
					} else {
						// 变了
						// this.isDisabled = false
					}
				},
				deep: true,
				immediate: true
			},
		},
		methods: {
			// 返回
			back() {
				this.$router.push({
					name: 'elevatorDetail',
					query: {
						object: this.parentData
					}
				})
			},
			getFloorList() {
				this.floorList = []
				if (this.ruleForm.MsgBody.DeviceParam.ElevFloorNumUnderGround - 0 >= this.ruleForm.MsgBody.DeviceParam
					.ElevFloorNum - 0) {
					this.$message.error('地下楼层数不能大于或等于总楼层数')
					return false
				}
				let num = this.ruleForm.MsgBody.DeviceParam.ElevFloorNum
				let num1 = this.ruleForm.MsgBody.DeviceParam.ElevFloorNumUnderGround
				if (!this.ruleForm.MsgBody.DeviceParam.FloorName || this.ruleForm.MsgBody.DeviceParam.FloorName.length ==
					0) {
					for (let i = 1; i <= num1; i++) {
						this.floorList.unshift({
							name: -i,
							value: ''
						})
					}
					for (let i = 1; i <= num - num1; i++) {
						this.floorList.push({
							name: i,
							value: ''
						})
					}
				} else {
					for (let i = 1; i <= num1; i++) {
						this.floorList.unshift({
							name: -i,
							value: ''
						})
					}
					for (let i = 1; i <= num - num1; i++) {
						this.floorList.push({
							name: i,
							value: ''
						})
					}
					console.log(this.ruleForm.MsgBody.DeviceParam.FloorName)
					// [[0,'B2'],[0,'B2'],[0,'G1']]
					// let arr = this.ruleForm.MsgBody.DeviceParam.FloorName
					let arr = [['-2', 'B2'], ['-1', 'B1'], ['1', 'G1'], ['2', 'G2']]
					for (var i = 0; i < arr.length; i++) {
						for (var j = 0; j < arr[i].length; j++) {
							if (j == 0) { // 检查是否是第一项
								this.floorList.forEach(item => {
									if (item.name == arr[i][j]) {
										item.value = arr[i][j + 1]
									}
								})
							}
						}
					}
				}
				console.log(this.floorList)
			},
			// 获取设备参数
			getDeviceRead() {
				let loading = this.$loading()
				this.$postJson(`aapi/getLiftDeviceList`, {
					'token': 'zlj365',
					'regcode': this.regcode
				}).then(
					res => {
						loading.close()
						console.log(res)
						if (res && res.errCode === 0) {
							if (res.liftInfo) {
								this.ruleForm = res.liftInfo
								this.saveData = JSON.stringify(res.liftInfo)
								// this.isDisabled = true
								this.getFloorList()
							} else {
								this.$message.error('获取设备信息失败')
								this.back()
								// this.isDisabled = true
							}
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					})
			},
			save() {
				console.log(this.floorList)
				let jsonArray = this.floorList
				let arr = []
				jsonArray.forEach((obj) => {
					if (obj.value) {
						let arr1 = []
						arr1.push(obj.name.toString())
						arr1.push(obj.value)
						arr.push(arr1)
					}
				})
				console.log(arr)
				this.$refs['ruleForm'].validate(valid => {
					if (valid) {
						let loading = this.$loading()
						this.$postJson(`aapi/setLiftDeviceParam`, {
							'token': 'zlj365',
							'regcode': this.regcode,
							'LanIP': this.ruleForm.MsgBody.CommonParam.LanIP,
							'LanMask': this.ruleForm.MsgBody.CommonParam.LanMask,
							'LanGateway': this.ruleForm.MsgBody.CommonParam.LanGateway,
							'LanMAC': this.ruleForm.MsgBody.CommonParam.LanMAC,
							'RegIP': this.ruleForm.MsgBody.CommonParam.RegIP,
							'RegPort': this.ruleForm.MsgBody.CommonParam.RegPort,
							'LiftCode': this.ruleForm.MsgBody.DeviceParam.LiftCode,
							'Address': this.ruleForm.MsgBody.DeviceParam.Address,
							'ElevLightShieldLength': this.ruleForm.MsgBody.DeviceParam.ElevLightShieldLength - 0,
							'ElevFloorNum': this.ruleForm.MsgBody.DeviceParam.ElevFloorNum - 0,
							'ElevFloorNumUnderGround': this.ruleForm.MsgBody.DeviceParam.ElevFloorNumUnderGround - 0,
							'TwinDoor': this.ruleForm.MsgBody.DeviceParam.TwinDoor - 0,
							'ElevMaxSpeed': this.ruleForm.MsgBody.DeviceParam.ElevMaxSpeed - 0,
							'NoActionClearTime': this.ruleForm.MsgBody.DeviceParam.NoActionClearTime - 0,
							'LvlClearTime': this.ruleForm.MsgBody.DeviceParam.LvlClearTime - 0,
							'DoorCloseJudgeTime': this.ruleForm.MsgBody.DeviceParam.DoorCloseJudgeTime - 0,
							'JudgeNoPeopleTime': this.ruleForm.MsgBody.DeviceParam.JudgeNoPeopleTime - 0,
							'AlarmPeopleTime': this.ruleForm.MsgBody.DeviceParam.AlarmPeopleTime - 0,
							'AlarmNoPeopleTime': this.ruleForm.MsgBody.DeviceParam.AlarmNoPeopleTime - 0,
							'NoAlarmPeopleTime': this.ruleForm.MsgBody.DeviceParam.NoAlarmPeopleTime - 0,
							'OverSpeed': this.ruleForm.MsgBody.DeviceParam.OverSpeed - 0,
							'CollideUpMask': this.ruleForm.MsgBody.DeviceParam.CollideUpMask,
							'CollideBottomMask': this.ruleForm.MsgBody.DeviceParam.CollideBottomMask,
							'DoorOpenRunMask': this.ruleForm.MsgBody.DeviceParam.DoorOpenRunMask,
							'NoLvlMask': this.ruleForm.MsgBody.DeviceParam.NoLvlMask,
							'OverSpeedMask': this.ruleForm.MsgBody.DeviceParam.OverSpeedMask,
							'PeopleTrapMask': this.ruleForm.MsgBody.DeviceParam.PeopleTrapMask,
							'MoveAbnomalMask': this.ruleForm.MsgBody.DeviceParam.MoveAbnomalMask,
							'FloorName': arr,
							'VisitorFLoor': [],
							'FloorBase': this.ruleForm.MsgBody.DeviceParam.FloorBase - 0,
						}).then(
							res => {
								loading.close()
								console.log(res)
								if (res && res.errCode === 0) {
									this.$message.success('保存成功')
									this.back()
								} else {
									this.$message.error(res.errMsg)
								}
							},
							error => {
								loading.close()
								this.$message.error(error)
							})
					}
				})
			},
		}
	}
</script>

<style lang="scss">
	.editPreInfo {
		.item-input {
			width: 30%;
		}
	}
</style>